WiseMetering.Views.EditSiteDocument = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'site_document',
    template: 'templates/site_documents/edit',
    title: () => i18next.t('modal.title.site_documents.edit')
});
